export default __webpack_public_path__ + "static/media/musacawes.63402465.png";